export const formatPercentage = (percentage: number | string) => {
    if (!percentage) return '';

    if (typeof percentage === 'number') {
        percentage = percentage.toFixed(0);
    }

    return `-${percentage}%`;
};

export const isNumber = (value: any): boolean => {
    return !!(value && +value - +value < 1);
};

export const roundNumber = (value: number, digit = 1) => {
    if (!isNumber(value)) {
        return 0;
    }
    return +value.toFixed(digit);
};
